import { render, staticRenderFns } from "./EspacoAlegre3.vue?vue&type=template&id=51df4a9a&scoped=true"
import script from "./EspacoAlegre3.vue?vue&type=script&lang=js"
export * from "./EspacoAlegre3.vue?vue&type=script&lang=js"
import style0 from "./EspacoAlegre3.vue?vue&type=style&index=0&id=51df4a9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51df4a9a",
  null
  
)

export default component.exports